import React from 'react';
import Types from 'prop-types';
import FooterTextLink from '../../common/FooterTextLink';
var FooterBottomItem = function FooterBottomItem(_ref) {
  var link = _ref.link,
    translationKey = _ref.translationKey;
  return /*#__PURE__*/React.createElement(FooterTextLink, {
    translationKey: translationKey,
    link: link
  });
};
FooterBottomItem.defaultProps = {
  translationKey: null
};
export default FooterBottomItem;